import * as React from "react";
import { SVGProps } from "react";

const Bitshares = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1226 1984" {...props}>
    <path
      fill="#35baeb"
      d="M427.5 1244 0 816.5v513.8h394c4.6-30.8 16-60.3 33.5-86.3zM394 1414.6H0c9.1 133.8 61.5 261.1 149.3 362.6l278.2-281.3c-17.7-24-29.2-51.9-33.5-81.3zm621.4-506.7c-100.4-89.4-228.2-142-362.5-149.4v393.6c30.2 4.9 58.9 16.1 84.3 33.1l278.2-277.3zm-213.2 583.9 278.2 278.2c86.2-100.1 137.5-225.6 146.2-357.5h-396c-4.7 27.9-14.3 54.7-28.4 79.3zm28.5-161.4h394c-9.1-133.8-61.5-261.1-149.3-362.6L797.1 1247c17.5 24.8 29 53.4 33.6 83.4zm-622 505.2c100.5 89.4 228.3 142 362.6 149.3v-394.5c-30.2-4.9-58.9-16.1-84.3-33.1l-278.3 278.3zm444.2-245.3v394c134.3-9 261.8-62.2 362.6-151.4l-276.3-276.3c-26.2 16.9-55.5 28.3-86.3 33.7zM0 689.1c105.6 105.6 436.7 439.7 492.5 494.5 23.8-14.7 49.9-25.4 77.2-31.5V508.8L1 0C0 0 0 670.3 0 689.1z"
    />
  </svg>
);

export default Bitshares;
